// extracted by mini-css-extract-plugin
module.exports = {"counselor-table":"counselor-table-cd19fea3de8a4842468f27c4f53c2196"};